const CollectionPointType = Object.freeze({
    PHARMACY: 0,
    PLACE_OF_WORSHIP: 1,
    RETAIL: 2,
    COMMUNITY_CENTRE: 3
})

export default CollectionPointType